module.exports = __webpack_public_path__ + "img/logo-wordmark.a00f57ec.svg";